// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dms-input {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  flex-wrap: nowrap;
  color: var(--text-color, #111827);
}

.dms-input__field {
  width: 2.6rem;
  min-height: 1.7rem;
  padding: 2px 4px;
  border: 1px solid var(--border-color, rgba(15, 23, 42, 0.18));
  border-radius: 6px;
  background: var(--surface-color, #fff);
  color: var(--text-color, #111827);
  font: inherit;
  font-size: 0.85rem;
  font-variant-numeric: tabular-nums;
  text-align: center;
}

.dms-input__field--sec {
  width: 2.4rem;
}

.dms-input__field:disabled,
.dms-input__field[readonly] {
  opacity: 0.75;
  background: color-mix(in srgb, var(--text-color, #111827) 6%, var(--surface-color, #fff));
}

.dms-input__field:focus {
  outline: none;
  border-color: var(--brand-primary, #0877bc);
}

/* Minutes / seconds labels — must stay readable in light and dark view modes */
.dms-input__unit {
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--text-secondary, #4b5563);
  letter-spacing: 0.02em;
  flex-shrink: 0;
}

.light-mode .dms-input__unit,
html[data-theme="light"] .dms-input__unit {
  color: var(--text-secondary, #4b5563);
}

.dark-mode .dms-input__unit,
html[data-theme="dark"] .dms-input__unit {
  /* Keep units clearly readable on dark surfaces (not inherited slate) */
  color: color-mix(in srgb, var(--text-color, #f9fafb) 78%, transparent);
}

.dms-input--compact .dms-input__field {
  width: 2.1rem;
  min-height: 1.4rem;
  font-size: 0.72rem;
  padding: 1px 2px;
}

.dms-input--compact .dms-input__field--sec {
  width: 2rem;
}

.dms-input--compact .dms-input__unit {
  font-size: 0.65rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/DurationMinutesSecondsInput.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,kBAAkB;EAClB,sCAAsC;EACtC,iCAAiC;EACjC,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,yFAAyF;AAC3F;;AAEA;EACE,aAAa;EACb,2CAA2C;AAC7C;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,uEAAuE;EACvE,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".dms-input {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  flex-wrap: nowrap;\n  color: var(--text-color, #111827);\n}\n\n.dms-input__field {\n  width: 2.6rem;\n  min-height: 1.7rem;\n  padding: 2px 4px;\n  border: 1px solid var(--border-color, rgba(15, 23, 42, 0.18));\n  border-radius: 6px;\n  background: var(--surface-color, #fff);\n  color: var(--text-color, #111827);\n  font: inherit;\n  font-size: 0.85rem;\n  font-variant-numeric: tabular-nums;\n  text-align: center;\n}\n\n.dms-input__field--sec {\n  width: 2.4rem;\n}\n\n.dms-input__field:disabled,\n.dms-input__field[readonly] {\n  opacity: 0.75;\n  background: color-mix(in srgb, var(--text-color, #111827) 6%, var(--surface-color, #fff));\n}\n\n.dms-input__field:focus {\n  outline: none;\n  border-color: var(--brand-primary, #0877bc);\n}\n\n/* Minutes / seconds labels — must stay readable in light and dark view modes */\n.dms-input__unit {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: var(--text-secondary, #4b5563);\n  letter-spacing: 0.02em;\n  flex-shrink: 0;\n}\n\n.light-mode .dms-input__unit,\nhtml[data-theme=\"light\"] .dms-input__unit {\n  color: var(--text-secondary, #4b5563);\n}\n\n.dark-mode .dms-input__unit,\nhtml[data-theme=\"dark\"] .dms-input__unit {\n  /* Keep units clearly readable on dark surfaces (not inherited slate) */\n  color: color-mix(in srgb, var(--text-color, #f9fafb) 78%, transparent);\n}\n\n.dms-input--compact .dms-input__field {\n  width: 2.1rem;\n  min-height: 1.4rem;\n  font-size: 0.72rem;\n  padding: 1px 2px;\n}\n\n.dms-input--compact .dms-input__field--sec {\n  width: 2rem;\n}\n\n.dms-input--compact .dms-input__unit {\n  font-size: 0.65rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
